import React from 'react';
import '../styles/Citarnos.css';

const Citarnos = () => {
  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="citarnos-hero-section">
        <div className="citarnos-hero-container">
          <div className="citarnos-hero-card">
            <h1 className="citarnos-hero-title">
              Cómo Citar la <span className="citarnos-hero-title-gradient">RESNOM</span>
            </h1>
            <p className="citarnos-hero-description">
              Información para citar correctamente los datos y recursos de la Red Sísmica del Noroeste de México en trabajos académicos y de investigación.
            </p>
          </div>
        </div>
      </header>

      {/* Citas Section */}
      <section className="citarnos-content-section">
        <div className="citarnos-content-container">
          <div className="citarnos-content-grid">
            <div className="citarnos-content-card">
              <h2 className="citarnos-content-title">Cita General de la RESNOM</h2>
              <div className="citarnos-citation">
                <p>
                  <strong>Red Sísmica del Noroeste de México (RESNOM)</strong>. Centro de Investigación Científica y de Educación Superior de Ensenada (CICESE). 
                  Disponible en: https://resnom.cicese.mx, DOI: https://doi.org/10.7914/SN/BC
                </p>
              </div>
            </div>
            
            <div className="citarnos-content-card">
              <h2 className="citarnos-content-title">Cita para Datos Sísmicos</h2>
              <div className="citarnos-citation">
                <p>
                  <strong>Datos sísmicos de la RESNOM</strong>. Red Sísmica del Noroeste de México, CICESE. 
                  [Fecha de acceso: DD/MM/AAAA]. Disponible en: https://resnom.cicese.mx, DOI: https://doi.org/10.7914/SN/BC
                </p>
              </div>
            </div>
            
            <div className="citarnos-content-card">
              <h2 className="citarnos-content-title">Cita para Publicaciones</h2>
              <div className="citarnos-citation">
                <p>
                  <strong>RESNOM</strong>. (2024). Red Sísmica del Noroeste de México. 
                  Centro de Investigación Científica y de Educación Superior de Ensenada. 
                  https://resnom.cicese.mx, DOI: https://doi.org/10.7914/SN/BC
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Información Adicional */}
      <section className="citarnos-info-section">
        <div className="citarnos-info-container">
          <h2 className="citarnos-info-title">Información Adicional</h2>
          <div className="citarnos-info-content">
            <p>
              Para citas más específicas o información detallada sobre el uso de datos de la RESNOM, 
              por favor contacta directamente con el equipo de la red sísmica.
            </p>
            <div className="citarnos-contact-info">
              <h3>Contacto para Citas Académicas:</h3>
              <p>Email: <a href="mailto:anunez@cicese.mx">anunez@cicese.mx</a></p>
              <p>Teléfono: +52 (646) 175-0500</p>
              <p>Dirección: Carretera Ensenada-Tijuana No. 3918, Ensenada, B.C., México</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Citarnos; 